import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgScrollbar } from 'ngx-scrollbar';
import { SmoothScrollToOptions } from 'ngx-scrollbar/smooth-scroll';
import { waitForCondition } from 'src/app/utilities/wait-for';

@Component({
  selector: 'app-scroll',
  templateUrl: './scroll.component.html',
  styleUrls: ['./scroll.component.scss'],
})
export class ScrollComponent implements OnInit {
  @ViewChild('content') content: NgScrollbar;
  @Input() pageId: string;

  constructor() {}

  async ngOnInit() {
    this.preventScrollbarFlickering();
  }

  async scrollTo(options?: SmoothScrollToOptions) {
    await waitForCondition(() => Boolean(this.content), true, 10);
    await this.content.scrollTo(options);
  }

  async preventScrollbarFlickering() {
    await waitForCondition(() => Boolean(this.content), true, 10);
    const scrollHeightHistories: { height: number; pageId: string; verticalUsed: boolean }[] = [];
    const update = scrollbar => {
      if (!scrollbar.autoHeightDisabled) {
        scrollbar.updateHeight();
      }

      if (!scrollbar.autoWidthDisabled) {
        scrollbar.updateWidth();
      }
      scrollbar.updateState();
      scrollbar.updated.next();
    };
    this.content.update = () => {
      const currentHeight = this.content.viewport?.scrollHeight;
      const verticalUsed = this.content.state.verticalUsed;
      scrollHeightHistories.push({ height: currentHeight, pageId: this.pageId, verticalUsed });
      // detect the flickering by looking at the height histories pattern
      // eg: 100 - 101 - 100 - 101
      if (
        scrollHeightHistories.length >= 3 &&
        scrollHeightHistories[scrollHeightHistories.length - 3].height === currentHeight &&
        scrollHeightHistories[scrollHeightHistories.length - 3].verticalUsed === verticalUsed &&
        scrollHeightHistories[scrollHeightHistories.length - 3].verticalUsed ===
          !scrollHeightHistories[scrollHeightHistories.length - 2].verticalUsed &&
        scrollHeightHistories[scrollHeightHistories.length - 2].pageId === this.pageId
      ) {
        // add the mininum height so it would stop the flickering because of auto-adjusted height
        const mainElem = this.content.nativeElement.querySelector('.ng-scroll-content > *') as HTMLElement;
        if (mainElem) {
          const currentHeight = mainElem.clientHeight;
          mainElem.style.minHeight = String(currentHeight + 10) + 'px';
        }
      }
      update(this.content);
    };
  }
}
